import React from 'react'
import Hero from '../../components/Hero/Hero';
import About from '../../components/About/About';
function Home() {
  return (
    <div>
      <Hero />
      <About />
    </div>
  )
}

export default Home